import { LanguageSwitcher } from '#features/i18n/components/LanguageSwitcher';

/** Keep language reachable before authentication, including in the native shell. */
export const AuthLanguageSelector = ({ disabled = false }: { disabled?: boolean }) => (
  <LanguageSwitcher presentation="picker" disabled={disabled} />
);
